import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
import { scpePrivacyPolicyLegalTypes } from '../utils/helpers'

/**
 * Note: with the addition of localization ( KP5-2217 )
 * Make sure the corresponding text has a key in <locale>.json file
 * Since it is dynamic follow the pattern to write a key for the localized version
 * 1. Trim and get first 30 chars
 * 2. Replace all <spaces> with <underscores>
 * 3. Append _text in the end.
 * one liner code : <string>.trim().substr(0,30).replaceAll(' ', '_').concat('_text')
 */
export const itemLabels = {
  registration_privacy_policy: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: `/en/privacy-policy`,
    closingText: '.'
  },
  privacy_policy_usa: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: `/en/privacy-policy-us`,
    closingText: '.'
  },
  privacy_policy_eu: {
    introText: 'Samsung Knox services use your personal data. Please refer to the ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: `/en/privacy-policy-eu`,
    closingText: ' for more details.'
  },
  privacy_policy_ko: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: `/en/privacy-policy-ko`,
    closingText: '.'
  },
  privacy_consent_ko: {
    introText: 'I have read and agree to the ',
    modalLink: 'Knox Privacy Notice',
    externalHref: `/en/privacy-consent`,
    closingText: '.'
  },
  privacy_policy_vn: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: `/en/privacy-policy-vn`,
    closingText: '.'
  },
  privacy_policy_tk: {
    introText: 'I agree to cross-border data transfer. ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: `/en/privacy-policy-tk`,
    closingText: ''
  },
  privacy_policy_br: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: '/en/privacy-policy-br',
    closingText: '.'
  },
  registration_terms_use: {
    introText: 'I, on behalf of the Company, have read and hereby agree to the ',
    modalLink: 'Samsung Knox Web Portal Terms of Use',
    externalHref: '/en/terms-use',
    closingText: '.'
  },
  kcs_product_terms_conditions: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Knox Product Terms and Conditions',
    externalHref: `${publicRuntimeConfig.uspBaseUrl}/termConditions`,
    closingText: '.'
  },
  // TO BE REMOVED. scb_privacy_policy was a placeholder that does not map
  // to any valid legal type.
  scb_privacy_policy: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Care+ for Business Privacy Policy',
    externalHref: '/en/scb-pp-us',
    closingText: '.'
  },
  kdp_participation_agreement: {
    introText: 'I have read and agree to the ',
    modalLink: 'Knox Deployment Program Participation Agreement',
    externalHref: `${publicRuntimeConfig.kcConsoleBaseUrlUs}/reseller/#state=resellereua`,
    closingText: '.'
  },
  msp_terms_agreement: {
    introText: 'I have read and agree to the ',
    modalLink: 'Knox Managed Service Provider (MSP) Program Terms and Conditions',
    externalHref: `${publicRuntimeConfig.uspBaseUrl}/mspadmin/termConditions`,
    closingText: '.'
  },
  kg_terms_agreement: {
    introText: 'I have read and agree to the ',
    modalLink: 'Knox Guard Terms and Conditions',
    externalHref: `${publicRuntimeConfig.kgConsoleBaseUrlUs}/admin/termConditions`,
    closingText: '.'
  },
  kg_terms_agreement_non_eu: {
    introText: 'I have read and agree to the ',
    modalLink: 'Knox Guard Terms and Conditions',
    externalHref: `${publicRuntimeConfig.kgConsoleBaseUrlUs}/admin/termConditions`,
    closingText: '.'
  },
  kg_terms_agreement_eu: {
    introText: 'I have read and agree to the ',
    modalLink: 'Knox Guard Terms and Conditions',
    externalHref: `${publicRuntimeConfig.kgConsoleBaseUrlEu}/admin/termConditions`,
    closingText: '.'
  },
  kcs_data_processing_agreement: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Data Processing Agreement',
    externalHref: '/en/data-processing-agreement',
    closingText: '.'
  },
  privacy_policy_cpro: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Care Pro Privacy Policy',
    externalHref: `/en/privacy-policy-cpro`,
    closingText: '.'
  },
  cpro_terms_and_conditions: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Business Services Terms and Conditions',
    externalHref: `/en/term-conditions/services`,
    closingText: '.'
  },
  receiveEmails: {
    introText:
      'I want to receive information and updates on Samsung Knox products and services, events, and promotions via email. (Optional) ',
    modalLink: '',
    closingText: ''
  }
}

export const kaaItemLabels = {
  registration_privacy_policy_kaa: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: `/en/privacy-policy?kaa`,
    closingText: '.'
  },
  privacy_policy_usa_kaa: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: `/en/privacy-policy-us-kaa`,
    closingText: '.'
  },
  privacy_policy_eu_kaa: {
    introText: 'Samsung Knox services use your personal data. Please refer to the ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: `/en/privacy-policy-eu-kaa`,
    closingText: ' for more details.'
  },
  privacy_policy_ko_kaa: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: `/en/privacy-policy-ko-kaa`,
    closingText: '.'
  },
  privacy_consent_ko_kaa: {
    introText: 'I have read and agree to the ',
    modalLink: 'Knox Privacy Notice',
    externalHref: `/en/privacy-consent-kaa`,
    closingText: '.'
  },
  privacy_policy_vn_kaa: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: `/en/privacy-policy-vn-kaa`,
    closingText: '.'
  },
  privacy_policy_tk_kaa: {
    introText: 'I agree to cross-border data transfer. ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: `/en/privacy-policy-tk-kaa`,
    closingText: ''
  },
  privacy_policy_br_kaa: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Knox Privacy Policy',
    externalHref: '/en/privacy-policy-br-kaa',
    closingText: '.'
  },
  registration_terms_use: {
    introText: 'I, on behalf of the Company, have read and hereby agree to the ',
    modalLink: 'Samsung Knox Web Portal Terms of Use',
    externalHref: '/en/terms-use',
    closingText: '.'
  },
  kcs_product_terms_conditions: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Knox Product Terms and Conditions',
    externalHref: `${publicRuntimeConfig.uspBaseUrl}/termConditionsKAA`,
    closingText: '.'
  },
  // TO BE REMOVED. scb_privacy_policy was a placeholder that does not map
  // to any valid legal type.
  scb_privacy_policy: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Care+ for Business Privacy Policy',
    externalHref: '/en/scb-pp-us',
    closingText: '.'
  },
  kdp_participation_agreement: {
    introText: 'I have read and agree to the ',
    modalLink: 'Knox Deployment Program Participation Agreement',
    externalHref: `${publicRuntimeConfig.kcConsoleBaseUrlUs}/reseller/#state=resellereua`,
    closingText: '.'
  },
  msp_terms_agreement: {
    introText: 'I have read and agree to the ',
    modalLink: 'Knox Managed Service Provider (MSP) Program Terms and Conditions',
    externalHref: `${publicRuntimeConfig.uspBaseUrl}/mspadmin/termConditions`,
    closingText: '.'
  },
  kg_terms_agreement: {
    introText: 'I have read and agree to the ',
    modalLink: 'Knox Guard Terms and Conditions',
    externalHref: `${publicRuntimeConfig.kgConsoleBaseUrlUs}/admin/termConditions`,
    closingText: '.'
  },
  kg_terms_agreement_non_eu: {
    introText: 'I have read and agree to the ',
    modalLink: 'Knox Guard Terms and Conditions',
    externalHref: `${publicRuntimeConfig.kgConsoleBaseUrlUs}/admin/termConditions`,
    closingText: '.'
  },
  kg_terms_agreement_eu: {
    introText: 'I have read and agree to the ',
    modalLink: 'Knox Guard Terms and Conditions',
    externalHref: `${publicRuntimeConfig.kgConsoleBaseUrlEu}/admin/termConditions`,
    closingText: '.'
  },
  kcs_data_processing_agreement_kaa: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Data Processing Agreement',
    externalHref: '/en/data-processing-agreement-kaa',
    closingText: '.'
  },
  privacy_policy_cpro: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Care Pro Privacy Policy',
    externalHref: `/en/privacy-policy-cpro`,
    closingText: '.'
  },
  cpro_terms_and_conditions: {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Business Services Terms and Conditions',
    externalHref: `/en/term-conditions/services`,
    closingText: '.'
  },
  receiveEmails: {
    introText:
      'I want to receive information and updates on Samsung Knox products and services, events, and promotions via email. (Optional) ',
    modalLink: '',
    closingText: ''
  }
}

const scpeLegalTypes = scpePrivacyPolicyLegalTypes()
scpeLegalTypes.forEach((type) => {
  itemLabels[type] = {
    introText: 'I have read and agree to the ',
    modalLink: 'Samsung Care+ for Business Privacy Policy',
    // This is only a fallback. externalHref is filled in dynamically at runtime via
    // GET /api/v1/register/legalDocsForCountry/{country}
    externalHref: '/en/scb-pp-us',
    closingText: '.'
  }
})
